export default "__VITE_ASSET__WQQb3qpa__"